import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

export const Footer = () => {
  const { t, localizedPath } = useI18n();

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-800 bg-[#0B1F3F] text-slate-200"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-14 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div>
          <div className="mb-4 flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-[#C85A32] font-serif text-lg font-bold text-white">
              Z
            </span>
            <span className="font-serif text-lg font-bold tracking-wide text-white">
              ZELVONIQ
            </span>
          </div>
          <h4 className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
            {t("footer.about_title")}
          </h4>
          <p className="text-sm leading-relaxed text-slate-300">
            {t("footer.about_text")}
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
            {t("footer.contact_title")}
          </h4>
          <ul className="space-y-2 text-sm text-slate-300">
            <li>
              <div className="text-slate-400">{t("footer.address_label")}</div>
              <div className="text-slate-200">{t("footer.address_value")}</div>
            </li>
            <li>
              <div className="text-slate-400">{t("footer.email_label")}</div>
              <a
                href={`mailto:${t("footer.email_value")}`}
                data-testid="footer-email-link"
                className="text-slate-200 hover:text-white"
              >
                {t("footer.email_value")}
              </a>
            </li>
            <li>
              <div className="text-slate-400">{t("footer.phone_label")}</div>
              <a
                href={`tel:${t("footer.phone_value").replace(/\s/g, "")}`}
                data-testid="footer-phone-link"
                className="text-slate-200 hover:text-white"
              >
                {t("footer.phone_value")}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
            {t("footer.legal_title")}
          </h4>
          <ul className="space-y-2 text-sm text-slate-300">
            <li>{t("footer.legal_company")}</li>
            <li>{t("footer.legal_registration")}</li>
            <li>{t("footer.legal_tax")}</li>
            <li>{t("footer.legal_license")}</li>
            <li>{t("footer.legal_jurisdiction")}</li>
            <li>{t("footer.legal_founded")}</li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">
            {t("footer.links_title")}
          </h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to={localizedPath("/privacy-policy")}
                data-testid="footer-link-privacy"
                className="text-slate-200 hover:text-white"
              >
                {t("footer.link_privacy")}
              </Link>
            </li>
            <li>
              <Link
                to={localizedPath("/cookie-policy")}
                data-testid="footer-link-cookies"
                className="text-slate-200 hover:text-white"
              >
                {t("footer.link_cookies")}
              </Link>
            </li>
            <li>
              <Link
                to={localizedPath("/terms-conditions")}
                data-testid="footer-link-terms"
                className="text-slate-200 hover:text-white"
              >
                {t("footer.link_terms")}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <p className="mb-3 text-xs leading-relaxed text-slate-400">
            {t("footer.disclaimer")}
          </p>
          <p className="text-xs text-slate-500">{t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
};
